(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctw-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GA_ID = 'G-7MYH1ED2J4';
    var META_PIXEL_ID = '1902971686491415';
    var CTW_TRACK_URL = 'https://darlin-member.darlinofficial.workers.dev/api/ctw-track';
    var CTW_BOOK_URL = 'https://darlin-member.darlinofficial.workers.dev/api/ctw-booking';
    var CTW_CALENDAR_URL = 'https://darlin-member.darlinofficial.workers.dev/ctw-live-calendar.ics';
    var CTW_GOOGLE_CALENDAR_URL = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=DARLIN%20LAZY%20WALK%20%E2%80%94%20TikTok%20LIVE&dates=20261002T113000Z%2F20261002T140000Z&details=LIVE%20Preview%20%E0%B9%80%E0%B8%A7%E0%B8%A5%E0%B8%B2%2018.30%20%E0%B8%99.%20%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%80%E0%B8%A3%E0%B8%B4%E0%B9%88%E0%B8%A1%E0%B8%8A%E0%B9%89%E0%B8%AD%E0%B8%9B%2019.00%20%E0%B8%99.%20%E0%B8%97%E0%B8%B5%E0%B9%88%20TikTok%20%40darlinjewelry&location=TikTok%20%40darlinjewelry&ctz=Asia%2FBangkok';

    function campaignAttribution() {
      var params = new URLSearchParams(window.location.search);
      var result = {};
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','campaign_id','adset_id','ad_id','placement'].forEach(function (key) {
        var value = params.get(key);
        if (value && !/[{}]/.test(value)) result[key] = value.slice(0, 100);
      });
      try {
        if (Object.keys(result).length) window.sessionStorage.setItem('darlin_ctw_attribution_v1', JSON.stringify(result));
        else result = JSON.parse(window.sessionStorage.getItem('darlin_ctw_attribution_v1') || '{}');
      } catch (e) {}
      return result;
    }

    function campaignSource() {
      var params = new URLSearchParams(window.location.search);
      var explicit = campaignAttribution().utm_source || params.get('src');
      if (explicit) return ({fb:'facebook',ig:'instagram',an:'audience_network',msg:'messenger',th:'threads'})[explicit] || explicit.slice(0, 80);
      if (/\bLine\//i.test(navigator.userAgent || '')) return 'line-in-app';
      if (document.referrer) {
        try { return new URL(document.referrer).hostname.replace(/^www\./, '').slice(0, 80); } catch (e) {}
      }
      return 'direct';
    }

    function visitorId() {
      var key = 'darlin_ctw_vid';
      try {
        var current = window.localStorage.getItem(key);
        if (current) return current;
        current = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
        window.localStorage.setItem(key, current);
        return current;
      } catch (e) { return ''; }
    }

    function trackFirstParty(name, payload) {
      var body = JSON.stringify({
        event: name,
        source: payload.source,
        visitor_id: visitorId(),
        page_path: window.location.pathname,
        attribution: campaignAttribution(),
        detail: payload.cta_position || payload.provider || payload.slot || payload.state || payload.color || ''
      });
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(CTW_TRACK_URL, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        } else {
          fetch(CTW_TRACK_URL, { method: 'POST', headers: { 'content-type': 'text/plain;charset=UTF-8' }, body: body, keepalive: true, mode: 'cors' }).catch(function () {});
        }
      } catch (e) {}
    }

    function track(name, parameters, options) {
      options = options || {};
      var payload = Object.assign({ campaign: 'ctw_lazy_walk_2026', source: campaignSource() }, parameters || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));

      try { if (typeof window.gtag === 'function') {
        window.gtag('event', name, Object.assign({ send_to: GA_ID }, payload));
      } } catch (e) {}
      try { if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, Object.assign({ pixel_id: META_PIXEL_ID }, payload), options.eventId ? { eventID: options.eventId } : {});
      } } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      } } catch (e) {}
      if (!options.serverRecorded) trackFirstParty(name, payload);
    }

    function initializeCountdown(root) {
      var countdown = root.querySelector('[data-ctw-countdown]');
      if (!countdown) return;

      function update() {
        countdown.querySelectorAll('[data-countdown-target]').forEach(function (item) {
          var output = item.querySelector('[data-countdown-value]');
          var remaining = new Date(item.dataset.countdownTarget).getTime() - Date.now();
          if (remaining <= 0) {
            output.textContent = countdown.dataset.live;
            return;
          }
          var totalMinutes = Math.floor(remaining / 60000);
          var days = Math.floor(totalMinutes / 1440);
          var hours = Math.floor((totalMinutes % 1440) / 60);
          var minutes = totalMinutes % 60;
          output.textContent = days + ' ' + countdown.dataset.days + ' · ' + hours + ' ' + countdown.dataset.hours + ' · ' + minutes + ' ' + countdown.dataset.minutes;
        });
      }

      update();
      window.setInterval(update, 60000);
    }

    function initializeVideo(root) {
      var video = root.querySelector('.ctw-landing__video');
      var toggle = root.querySelector('[data-ctw-video-toggle]');
      if (!video || !toggle) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) video.pause();

      function render() {
        var paused = video.paused;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'เล่นวิดีโอ' : 'หยุดวิดีโอชั่วคราว');
        toggle.querySelector('[data-ctw-video-icon]').textContent = paused ? '▶' : 'Ⅱ';
      }

      toggle.addEventListener('click', function () {
        if (video.paused) video.play().catch(function () {});
        else video.pause();
        render();
        track('ctw_video_toggle', { state: video.paused ? 'paused' : 'playing' });
      });
      video.addEventListener('play', render);
      video.addEventListener('pause', render);
      render();

      var automaticPause = false;
      var userPaused = false;
      video.addEventListener('pause', function () {
        if (!automaticPause && !video.ended) userPaused = true;
        automaticPause = false;
      });
      video.addEventListener('play', function () { userPaused = false; });
      if ('IntersectionObserver' in window && !reduceMotion) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !userPaused && !video.ended) video.play().catch(function () {});
            else if (!entry.isIntersecting && !video.paused) {
              automaticPause = true;
              video.pause();
            }
          });
        }, { threshold: 0.4 });
        observer.observe(video);
      }

    }

    function initializeCarousel(root) {
      var viewport = root.querySelector('.ctw-landing__carousel-viewport');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ctw-landing__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ctw-carousel-dot]'));
      var status = root.querySelector('[data-ctw-carousel-status]');
      if (!viewport || !slides.length || !dots.length) return;

      function activate(index, shouldTrack) {
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (status) status.textContent = slides[index].dataset.slideCaption || '';
        if (shouldTrack) track('ctw_carousel_select', { slide_index: index + 1, color: slides[index].dataset.slideCaption || '' });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          slides[index].scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
          activate(index, true);
        });
      });

      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
          activate(Math.max(0, Math.min(index, slides.length - 1)), false);
          ticking = false;
        });
      }, { passive: true });
      activate(0, false);
    }

    function openDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    function initializeActions(root) {
      var calendarDialog = root.querySelector('[data-ctw-calendar-dialog]');
      var bookingDialog = root.querySelector('[data-ctw-booking-dialog]');
      var appleLink = root.querySelector('[data-ctw-calendar-provider="apple"]');
      var googleLink = root.querySelector('[data-ctw-calendar-provider="google"]');
      var bookingForm = root.querySelector('[data-ctw-booking-form]');

      if (appleLink) {
        appleLink.href = CTW_CALENDAR_URL + '?src=' + encodeURIComponent(campaignSource()) + '&vid=' + encodeURIComponent(visitorId());
        appleLink.addEventListener('click', function () { track('ctw_calendar_add', { provider: 'apple' }); });
      }
      if (googleLink) {
        googleLink.href = CTW_GOOGLE_CALENDAR_URL;
        googleLink.addEventListener('click', function () { track('ctw_calendar_add', { provider: 'google' }); });
      }

      root.querySelectorAll('[data-ctw-calendar-open]').forEach(function (button) {
        button.addEventListener('click', function () {
          track('ctw_calendar_open', { cta_position: button.dataset.ctwCta || 'calendar' });
          openDialog(calendarDialog);
        });
      });
      root.querySelectorAll('[data-ctw-booking-open]').forEach(function (button) {
        button.addEventListener('click', function () {
          track('ctw_booking_form_open', { cta_position: button.dataset.ctwCta || 'booking' });
          openDialog(bookingDialog);
        });
      });

      [calendarDialog, bookingDialog].forEach(function (dialog) {
        if (!dialog) return;
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) dialog.close();
        });
      });

      if (!bookingForm) return;
      var queueLink = root.querySelector('[data-ctw-queue-link]');
      if (queueLink) queueLink.addEventListener('click', function () { track('ctw_queue_link_click'); });
      var lastInvalidAt = 0;
      bookingForm.addEventListener('invalid', function () {
        if (Date.now() - lastInvalidAt > 1000) track('ctw_booking_validation_error', { state: 'invalid_form' });
        lastInvalidAt = Date.now();
      }, true);
      bookingForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!bookingForm.reportValidity()) return;
        var submit = bookingForm.querySelector('[type="submit"]');
        if (submit.disabled) return;
        var status = root.querySelector('[data-ctw-booking-status]');
        var original = submit.textContent;
        submit.disabled = true;
        submit.textContent = bookingForm.dataset.submitting;
        status.textContent = '';
        var data = new FormData(bookingForm);
        track('ctw_booking_submit', { slot: data.get('slot') });
        fetch(CTW_BOOK_URL, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            name: data.get('name'), phone: data.get('phone'), slot: data.get('slot'),
            website: data.get('website'), source: campaignSource(), visitor_id: visitorId(), attribution: campaignAttribution()
          })
        }).then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok || json.status !== 'booked' || !json.booking_id || !json.queue_link) {
              var error = new Error(json.message || bookingForm.dataset.error);
              error.trackingCode = /^[A-Z_]{1,40}$/.test(json.code || '') ? json.code : 'HTTP_' + response.status;
              throw error;
            }
            return json;
          });
        }).then(function (json) {
          root.querySelector('[data-ctw-booking-content]').hidden = true;
          root.querySelector('[data-ctw-booking-success]').hidden = false;
          root.querySelector('[data-ctw-booking-slot]').textContent = '1 ต.ค. 2569 · ' + json.slot.replace('-', '–') + ' น.';
          root.querySelector('[data-ctw-booking-id]').textContent = json.booking_id;
          root.querySelector('[data-ctw-queue-link]').href = json.queue_link;
          if (json.created === true) {
            track('ctw_web_booking_success', { slot: json.slot }, { eventId: json.event_id, serverRecorded: true });
          } else {
            track('ctw_booking_recovered', { slot: json.slot });
          }
        }).catch(function (error) {
          track('ctw_booking_error', { state: error.trackingCode || 'NETWORK_OR_RESPONSE_ERROR' });
          status.textContent = error.message || bookingForm.dataset.error;
        }).finally(function () {
          submit.disabled = false;
          submit.textContent = original;
        });
      });
    }

    function initialize(root) {
      if (!root || root.dataset.ctwInitialized === 'true') return;
      root.dataset.ctwInitialized = 'true';
      initializeActions(root);
      initializeCountdown(root);
      initializeVideo(root);
      initializeCarousel(root);
      track('ctw_landing_view', { page_path: window.location.pathname });
    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches('[data-ctw-root]')) initialize(scope);
      scope.querySelectorAll('[data-ctw-root]').forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
